<template>
  <div class="pr-header pos-fix" id="prHeader" :class="{'tran-none': $route.meta.nav != 'home'}">
    <el-header height="80px">
      <el-row class="pr-header-row w-prec92" style="width:1228px">
        <el-col class="pt-4 pl-3">
          <el-col :span="5">
            <router-link to="/home"><img width="200px" src="../../assets/images/logo.png" alt=""></router-link>
          </el-col>
          <el-col :span="19">
            <el-menu :default-active="activeIndex" class="el-menu-demo float-r d-in-block" mode="horizontal">
              <el-menu-item index="1"><router-link to="/home">首页</router-link></el-menu-item>
              <el-submenu index="2" :show-timeout="100" :hide-timeout="200" popper-class="pr-nav-submenu">
                <template slot="title">主要服务</template>
                <el-menu-item index="2-1">
                  <router-link to="/service/consult">咨询服务</router-link>
                </el-menu-item>
                <el-menu-item index="2-2">
                  <router-link to="/service/tech">创新技术服务</router-link>
                </el-menu-item>
                <el-menu-item index="2-3">
                  <router-link to="/service/talent">人才服务</router-link>
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="3">
                <router-link to="/strengths">核心优势</router-link>
              </el-menu-item>
              <el-menu-item index="4">
                <router-link to="/case">经典案例</router-link>
              </el-menu-item>
			        <el-menu-item index="5" style="display: none;">
                <router-link to="/article/list/all">最新动态</router-link>
              </el-menu-item>
              <el-submenu index="6" :show-timeout="100" :hide-timeout="200" popper-class="pr-nav-submenu">
                <template slot="title">关于我们</template>
                <el-menu-item index="6-1">
                  <router-link to="/about/companyIntro">公司介绍</router-link>
                </el-menu-item>
                <el-menu-item index="6-2">
                  <router-link to="/about/teamIntro">团队介绍</router-link>
                </el-menu-item>
                <el-menu-item index="6-3">
                  <router-link to="/about/contact">联系我们</router-link>
                </el-menu-item>
              </el-submenu>
            </el-menu>

            <!-- <el-menu :default-active="activeIndex" class="el-menu-demo float-r d-in-block" mode="horizontal">
              <el-menu-item index="1"><router-link to="/home">首页</router-link></el-menu-item>
              <el-menu-item index="2"><router-link to="/about/companyIntro">公司介绍</router-link></el-menu-item>
              <el-menu-item index="3"><router-link to="/about/teamIntro">团队介绍</router-link></el-menu-item>
              <el-menu-item index="4"><router-link to="/about/contact">联系我们</router-link></el-menu-item>
            </el-menu> -->
          </el-col>
        </el-col>
      </el-row>
    </el-header>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '1',
    }
  },
  created() {

  },
  computed: {

  },
  watch: {
    $route(v) {
      let els1 = document.getElementsByClassName('el-submenu')[0];
      let els2 = document.getElementsByClassName('el-submenu')[1];
      if(v.meta.nav == "service") {
        els1.style.borderBottom = '2px solid #213752';
      }else {
        els1.style.borderBottom = 'none';
      }

      if(v.meta.nav == "about") {
        els2.style.borderBottom = '2px solid #213752';
      }else {
        els2.style.borderBottom = 'none';
      }

    }
  },
  mounted() {
    var that = this;
    window.onscroll = function() {
      if (window.scrollY > 2) {
        document.getElementById("prHeader").classList.add('scroll-nav');
      } else {
        document.getElementById("prHeader").classList.remove('scroll-nav');
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
.tran-none {
  transition: none !important;
}
.pr-header {
  width: 100%;
  top: 0px;
  padding-top: 10px; 
  z-index: 999;
  transition: background-color .5s;
  .pr-header-row {
    background: #fff;
    height: 80px;
    margin: 0 auto;
  }
  .el-menu.el-menu--horizontal {
    border: none;
    .router-link-exact-active {
      color: #213752;
      border-bottom: 2px solid #213755;
    }
    .el-menu-item {
      padding: 0px;
      margin: 0 32px;
      height: auto;
      line-height: 36px;
      color: #666;
      font-size: 14px;
      &.is-active {
        // color: #213752 !important;
        border: none;
      }
      a {
        display: block;
      }
    }
    .el-submenu {
      margin: 0 22px;
      &:last-child {
        margin-right: 10px;
      }
      .el-submenu__title {
        padding: 0 5px;
        height: auto;
        line-height: 36px;
        color: #666;
        font-size: 14px;
        border: none;
      }
      &.is-active .el-submenu__title {
        // color: #213752;
        border: none;
      }
    }
  }
}
.pr-nav-submenu {
  .el-menu--popup {
    min-width: 116px;
    box-shadow: none;
    .el-menu-item {
      a {
        display: block;
      }
      &:hover {
        color: #213752;
        background: rgba($color: #000000, $alpha: .05);
      }
    }
  }
  .el-menu--popup-bottom-start {
    margin-top: 18px;
  }

}
</style>
